<template>
  <div class="">
    <b-button
      v-b-toggle.transactionPointsHistory
      class="btn btn-lg btn-collapse"
    >
      {{ $t("transactionPointsHistory") }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </b-button>
    <b-collapse id="transactionPointsHistory">
      <div class="my-card">
        <div class="row">
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="transactionPointsHistoryView"
              v-model="
                usersPrivilegeTransactionPointsHistory.transactionPointsHistoryView
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="transactionPointsHistoryView">{{
              $t("view")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="transactionPointsHistoryIncrease"
              v-model="
                usersPrivilegeTransactionPointsHistory.transactionPointsHistoryIncrease
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="transactionPointsHistoryIncrease">{{
              $t("add")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="transactionPointsHistoryDecrease"
              v-model="
                usersPrivilegeTransactionPointsHistory.transactionPointsHistoryDecrease
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="transactionPointsHistoryDecrease">{{
              $t("discount")
            }}</label>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "UsersPrivilegeReservations",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["usersPrivilegeTransactionPointsHistory"],
  methods: {},
};
</script>

<style scoped lang="scss"></style>
